import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import LoadDetailsContainer from '../../../../components/componentsInventoryManagement/_Non_Lot_Tracking_Components/LoadDetails/LoadDetailsContainer';

class invManLoadDetailView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <LoadDetailsContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default invManLoadDetailView;
